export default __webpack_public_path__ + "static/media/spinningLogoReal.60968ff3.gif";